import { render, staticRenderFns } from "./HistoryOfChangesTable.vue?vue&type=template&id=21458cfb&scoped=true"
import script from "./HistoryOfChangesTable.vue?vue&type=script&lang=js"
export * from "./HistoryOfChangesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21458cfb",
  null
  
)

export default component.exports